import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from "./Badge";
import { SearchField } from "./SearchField";
import { Cart, Search } from "./icons";
import { bestReadableColor } from "./utils";
import { readableColor } from "polished";
import styled from "@emotion/styled";
import { useFlexMenu } from "./useFlexMenu";
import { colors } from "../theme";
import { Tooltip } from "./Tooltip";
import { Trans } from "@lingui/react";
import { toTestId } from "../utils";
const hoverOpacity = "0.6";
export function RTCHeaderDesktop4({ backgroundColor, bannerActive, bannerBackgroundColor, bannerContent, bannerTypography, bannerVisibility, containerSize, disabledCart, homeUrl, isInHome, itemsCount, logoColor, logoContent, logoImage, logoType, logoTypography, menu, menuMoreButtonText, menuTypography, onCartIconClick, onSearch, renderLink, searchOpen, searchPlaceholder, searchTerm, setSearchOpen, sticky, textColor, }) {
    const flexMenu = useFlexMenu(menu, 24);
    const logoImageParse = logoImage != null && logoImage !== ""
        ? JSON.parse(logoImage)
        : undefined;
    const showBanner = bannerActive &&
        ((bannerVisibility === "H" && isInHome) || bannerVisibility === "A");
    return (_jsxs(Header, Object.assign({ backgroundColor: backgroundColor, sticky: sticky }, { children: [showBanner && (_jsx(Banner, Object.assign({ backgroundColor: bannerBackgroundColor, "data-testid": "header-banner" }, { children: _jsx(BannerContent, { dangerouslySetInnerHTML: { __html: bannerContent }, typography: bannerTypography, textColor: bestReadableColor(textColor, bannerBackgroundColor) }, void 0) }), void 0)),
            _jsx(ContainerTop, Object.assign({ backgroundColor: backgroundColor }, { children: _jsxs(ContentTop, Object.assign({ backgroundColor: backgroundColor }, { children: [_jsxs(SearchContent, { children: [_jsx(IconButton, Object.assign({ color: readableColor(backgroundColor), onClick: () => setSearchOpen(o => !o), "data-testid": "search-icon" }, { children: _jsx(Search, {}, void 0) }), void 0),
                                _jsx(SearchField, { open: searchOpen, desktop: true, placeholder: searchPlaceholder, backgroundColor: backgroundColor, searchTerm: searchTerm, onSearch: onSearch }, void 0)] }, void 0),
                        logoType === "T" && (_jsx(Logo, Object.assign({ typography: logoTypography, color: logoColor }, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: logoContent }), void 0) }), void 0)),
                        logoType === "I" && (_jsx(LogoImage, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: _jsx("img", { src: logoImageParse === null || logoImageParse === void 0 ? void 0 : logoImageParse.medium, alt: "Logo de tu marca" }, void 0) }), void 0) }, void 0)),
                        _jsx(CartContent, { children: _jsx(Tooltip, Object.assign({ content: _jsx(Trans, { id: "No pod\u00E9s agregar productos al carrito en este momento" }, void 0), placement: "bottom-end", maxWidth: 200, disabled: !disabledCart }, { children: _jsx(IconButtonWrapper, { children: _jsx(IconButton, Object.assign({ color: readableColor(backgroundColor), onClick: onCartIconClick, "data-testid": "cart", disabled: disabledCart, disabledCart: disabledCart }, { children: itemsCount >= 1 ? (_jsx(Badge, Object.assign({ badgeContent: itemsCount, disabledCart: disabledCart }, { children: _jsx(Cart, {}, void 0) }), void 0)) : (_jsx(Cart, {}, void 0)) }), void 0) }, void 0) }), void 0) }, void 0)] }), void 0) }), void 0),
            _jsx(ContainerBottom, Object.assign({ backgroundColor: backgroundColor }, { children: _jsxs(Navigation, Object.assign({ backgroundColor: backgroundColor, containerWidth: containerSize.width, ref: flexMenu.listRef }, { children: [menu.map(({ id, title }) => (_jsx(InvisibleLink, Object.assign({ href: "#", typography: menuTypography, selectedColor: colors.black, textColor: colors.black, className: "invisible-link", tabIndex: -1, isActive: false }, { children: title }), id))),
                        flexMenu.visibleLinks.map(({ id, title, href, type }) => (_jsx(Link, Object.assign({ textColor: bestReadableColor(textColor, backgroundColor), selectedColor: hoverOpacity, typography: menuTypography, isActive: href === "/"
                                ? isInHome
                                : window.location.pathname.includes(href) }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                ? { rel: "noopener noreferrer", target: "_blank" }
                                : {}), { "data-testid": `${toTestId(title)}-link` }, { children: title }), void 0)) : (renderLink({ title, href })) }), id))),
                        _jsxs(ShowMore, Object.assign({ ref: flexMenu.showMoreButtonRef, isPresent: flexMenu.isMoreButtonVisible }, { children: [_jsxs(MoreButton, Object.assign({ normalColor: bestReadableColor(textColor, backgroundColor), typography: menuTypography }, flexMenu.moreButtonHandlers, { "data-testid": "more-button" }, { children: [menuMoreButtonText, " ", _jsx(Chevron, {}, void 0)] }), void 0),
                                _jsx(HiddenLinks, Object.assign({ show: flexMenu.showHiddenLinks }, flexMenu.hiddenLinksHandlers, { children: flexMenu.hiddenLinks.map(({ id, href, title, type }) => (_jsx(HiddenLink, Object.assign({ typography: menuTypography, linkColor: bestReadableColor(textColor, colors.white) }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                            ? { rel: "noopener noreferrer", target: "_blank" }
                                            : {}), { children: title }), void 0)) : (renderLink({ title, href })) }), id))) }), void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0));
}
const Header = styled.header(({ backgroundColor, sticky }) => (Object.assign({ backgroundColor, border: "none", display: "flex", flexDirection: "column", height: "auto", position: sticky ? "sticky" : "relative", width: "100%" }, (sticky
    ? {
        top: 0,
        zIndex: 9999,
    }
    : {}))));
const centeredGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 96rem 1fr",
};
const Banner = styled.div(({ backgroundColor }) => (Object.assign({ alignItems: "center", backgroundColor, minHeight: "5.2rem" }, centeredGrid)));
const BannerContent = styled.div(({ typography, textColor }) => ({
    color: textColor,
    fontFamily: typography,
    fontSize: "1.4rem",
    gridColumn: "2 / 3",
    textAlign: "center",
    padding: "1.6rem",
    "& p": {
        margin: 0,
        fontFamily: typography,
    },
}));
const ContainerTop = styled.div(({ backgroundColor }) => (Object.assign({ backgroundColor, height: "6rem", borderBottom: `solid 1px ${colors.greyMain}` }, centeredGrid)));
const ContentTop = styled.div(() => ({
    display: "grid",
    gridColumn: "2 / 3",
    gridGap: "0.4rem",
    gridTemplateColumns: "5.6rem auto 5.6rem",
}));
const Logo = styled.div(({ typography, color }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    maxHeight: "6rem",
    overflow: "hidden",
    wordBreak: "break-word",
    "& a": {
        textDecoration: "none",
        fontSize: "3.2rem",
        fontFamily: typography,
        color,
    },
}));
const ContainerBottom = styled.div(({ backgroundColor }) => (Object.assign({ backgroundColor, height: "6rem" }, centeredGrid)));
const Navigation = styled.nav(({ backgroundColor }) => ({
    alignItems: "center",
    display: "grid",
    gridAutoFlow: "column",
    gridColumn: "2 / 3",
    gridGap: "2.4rem",
    justifyContent: "center",
    "& svg": {
        color: readableColor(backgroundColor),
        fontSize: "2.4rem",
    },
}));
const Link = styled.span(({ textColor, typography, selectedColor, isActive }) => ({
    padding: "0.8rem 0",
    "& > a": Object.assign({ color: textColor, fontFamily: typography, fontSize: "1.6rem", textDecoration: "none", transition: "color 200ms ease-in-out", whiteSpace: "nowrap", "&:hover": {
            opacity: selectedColor,
        } }, (isActive
        ? {
            opacity: selectedColor,
        }
        : {})),
}));
const InvisibleLink = styled.a(({ textColor, typography, selectedColor }) => ({
    color: textColor,
    fontFamily: typography,
    fontSize: "1.6rem",
    padding: "0.8rem 0",
    textDecoration: "none",
    transition: "color 200ms ease-in-out",
    whiteSpace: "nowrap",
    "&:hover": {
        color: selectedColor,
    },
    position: "fixed",
    top: "-200%",
    pointerEvents: "none",
}));
const padding = "1.6rem";
const ShowMore = styled.div(({ isPresent }) => ({
    display: isPresent ? "block" : "none",
    position: "relative",
}));
const MoreButton = styled.span(({ normalColor, typography }) => ({
    alignItems: "center",
    color: normalColor,
    display: "inline-grid",
    fontFamily: typography,
    fontSize: "1.6rem",
    gridAutoFlow: "column",
    gridGap: "0.4rem",
    "&:hover": {
        fontWeight: "bold",
        color: hoverOpacity,
    },
    "& svg": {
        color: normalColor,
        height: "2.4rem",
        width: "2.4rem",
    },
    "&:hover svg": {
        color: hoverOpacity,
    },
}));
const HiddenLinks = styled.div(({ show }) => ({
    backgroundColor: colors.white,
    boxShadow: "0 0.4rem 0.8rem hsla(0, 0%, 0%, 0.15)",
    display: "flex",
    flexDirection: "column",
    gridGap: "0.8rem",
    maxWidth: "34rem",
    opacity: show ? 1 : 0,
    pointerEvents: show ? "all" : "none",
    position: "absolute",
    transform: show
        ? `translate(calc(-50% + (${padding} * 2)), 0px)`
        : `translate(calc(-50% + (${padding} * 2)), -10px)`,
    transformOrigin: "top center",
    transition: "all 200ms ease-in-out",
    width: "max-content",
    zIndex: show ? 100 : -100,
    wordBreak: "break-word",
}));
const HiddenLink = styled.span(({ typography, linkColor }) => ({
    padding: `calc(${padding} / 2) 1.2rem`,
    "& > a": {
        color: linkColor,
        fontFamily: typography,
        fontSize: "1.6rem",
        textAlign: "center",
        textDecoration: "none",
        transition: "background-color 200ms ease-in-out",
    },
    "&:hover": {
        backgroundColor: colors.greyLightest,
    },
}));
const Chevron = () => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512" }, { children: _jsx("path", { fill: "currentColor", d: "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" }, void 0) }), void 0));
const SearchContent = styled.div({
    display: "flex",
    position: "relative",
});
const CartContent = styled.div({
    justifyContent: "flex-end",
    display: "flex",
});
const IconButtonWrapper = styled.span(() => ({
    alignSelf: "center",
}));
const IconButton = styled.button(({ color, disabledCart }) => ({
    alignItems: "center",
    alignSelf: "center",
    background: "transparent",
    border: "none",
    display: "flex",
    height: "4rem",
    justifyContent: "center",
    justifySelf: "end",
    margin: "-0.8rem",
    padding: 0,
    width: "4rem",
    cursor: "pointer",
    "& svg": {
        color: disabledCart ? colors.greyMain : color,
        fontSize: "2.4rem",
    },
    "&:hover svg": {
        opacity: disabledCart ? 1 : hoverOpacity,
    },
}));
const LogoImage = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "6rem",
    padding: "0.8rem",
    "& a": {
        height: "100%",
    },
    "& img": {
        height: "100%",
    },
}));
//# sourceMappingURL=RTCHeaderDesktop4.js.map